<template>
  <div class="content">
    <div class="row">
        <card>
          <template slot="header">
            <h4 class="card-title">用户管理</h4>
          </template>
		  
		  <div class="row" style="margin-left:15px;">
		      <input type="text" class="form-control col-2" placeholder="手机" aria-label="手机" aria-describedby="basic-addon1"  v-model="searchData.param.mobile">
		  </div>
		  <div style="text-align:left"><button type="button" class="form-control btn btn-primary col-2" @click="getUsers()">查找</button>
			  <button type="button" class="form-control btn btn-primary col-2" @click="add()">邀请</button>
			  <button type="button" class="form-control btn btn-primary col-2" @click="edit()">编辑</button>
			  <button type="button" class="form-control btn btn-primary col-2" @click="roles()">角色设置</button>
		  </div>
          <div class="table-responsive text-left">
			  <el-table class="table" 
			  :data="users" width="100%"  
			  @current-change="handleCurrenChange"
			  highlight-current-row
			  tooltip-effect="dark"
			  >
			  <el-table-column prop="name" label="姓名"></el-table-column>
			  <el-table-column prop="mobile" label="电话"></el-table-column>
			  <el-table-column prop="email" label="邮箱"></el-table-column>
			  <el-table-column prop="loginName" label="登录名"></el-table-column>
			  <el-table-column prop="userState" label="用户状态"></el-table-column>
			  <el-table-column prop="roleName" label="角色"></el-table-column>			  
			  <el-table-column prop="createTime" label="创建时间"></el-table-column>
              </el-table>
          </div>
        </card>
    </div>
	
	<Modal :isVisible="showModal" @close="showModal = false">
		<template #header>
		    <div style="color:#000">
			邀请注册
			</div>
		</template>
		  
		<div class="row">
		<input type="text" class="form-control col-6" placeholder="电话" aria-label="电话" v-model.trim="invitation.tel">			
		</div>		
		
		<template #footer>
		  <span class="text-success" style="padding:15px;">{{msg}}</span>
		  <button @click="invite()" class="btn btn-primary">发出邀请</button>
		</template>
		
	</Modal>
	
	<Modal :isVisible="showModal2" @close="showModal2 = false">
		<template #header>
		    <div style="color:#000">
			编辑用户资料：  {{userDetail.name}}
			</div>
		</template>	  

		<div class="row" style="margin-top:10px;">电&nbsp;&nbsp;&nbsp;&nbsp;话：<input type="text" class="form-control col-6" placeholder="电话" label="电话" v-model.trim="userDetail.mobile"></div>
		<div class="row" style="margin-top:10px;">用户名：<input type="text" class="form-control col-6" placeholder="用户名" aria-label="用户名" v-model.trim="userDetail.name"></div>
		<div class="row" style="margin-top:10px;">登录名：<input type="text" class="form-control col-6" placeholder="登录名" aria-label="登录名" v-model.trim="userDetail.loginName"></div>
        <div class="row" style="margin-top:10px;">邮&nbsp;&nbsp;&nbsp;&nbsp;箱：<input type="text" class="form-control col-6" placeholder="登录名" aria-label="登录名" v-model.trim="userDetail.email"></div>
		<div class="row" style="margin-top:10px;">角&nbsp;&nbsp;&nbsp;&nbsp;色：
		<el-select  v-model="userDetail.roleId"  clearable placeholder="请选择">
			<el-option
			  v-for="item in roleDatas"
			  :key="item.roleId"
			  :label="item.roleName"
			  :value="item.roleId">
			</el-option>
		</el-select>
		</div>
		
		<div class="row" style="margin-top:10px;">状&nbsp;&nbsp;&nbsp;&nbsp;态：
		<el-select  v-model="userDetail.userState" placeholder="请选择">
			<el-option
			  v-for="item in userStatus"
			  :key="item.value"
			  :label="item.label"
			  :value="item.value">
			</el-option>
		</el-select>
		</div>
		<template #footer>
		  <span class="text-success" style="padding:15px;">{{msg}}</span>
		  <button @click="save()" class="btn btn-primary">修改</button>
		</template>
		
	</Modal>
	
	
	<Modal :isVisible="showModal3" @close="showModal3 = false">
		<template #header>
		    <div style="color:#000">
			角色编辑
			</div>
		</template>
		  
		<div class="row">
			<el-collapse accordion width="400px"  @change="getFuncs">
				
			  <el-collapse-item v-for="(item,index) in roleDatas" width="500px" :name="item.roleId">
			    <template slot="title">
					{{item.roleName}}
			    </template>
				<div>
					<el-tag
					  :key="index"
					  style="margin-right: 5px;margin-bottom: 5px;"
					  v-for="(tag,index) in funcs"
					  closable
					  :disable-transitions="false"
					  @close="handleClose(tag,item.roleId)">
					  {{tag}}
					</el-tag>
					<br/>
					<el-select  v-model="funcId" placeholder="请选择">
						<el-option
						  v-for="item in allFuncs"
						  :key="item.func_id"
						  :label="item.funcLangCode"
						  :value="item.funcId">
						</el-option>
					</el-select><i class="el-icon-plus" @click="addFunc(item.roleId)"></i>
				</div>
			  </el-collapse-item>
			  
			</el-collapse>		
		</div>
		
		<template #footer>		 
		</template>
		
	</Modal>
	

  </div>
</template>

<script>
import { Card } from "@/components/index";
import BaseTable from "@/components/BaseTable";
import Modal from "@/pages/Layout/Modal.vue";
import msg from "@/config/message.js";
import { Message,MessageBox} from "element-ui";
export default {
  components: {
    Card,
    BaseTable,
	Modal
  },
  data() {
    return {
	  users:[],
	  searchData:{
		  pages:1,
		  pageSize:20,
		  pageNum:1,
		  param:{
			  mobile:""
		  }
	  },
      invitation:{
		  tel:"",
		  code:"",
	  },
	  showModal:false,
	  showModal2:false,
	  showModal3:false,
	  currentRow:null,
	  userName:"",
	  userDetail:{
		  id:"",
		  name:"",
	      mobile:"",
		  loginName:"",
		  userState:"",
		  roleId:"",
		  email:""
	  },
	  userStatus: [{
	            value: 'ENABLE',
	            label: '启用'
	            }, {
	            value: 'DISABLE',
	            label: '停用'
	            }],
	  msg:"",
	  isSys: [{
	            value: 'Y',
	            label: '内部用户'
	            }, {
	            value: 'N',
	            label: '外部用户'
	            },{
				value:"",
				label:"未指定"
				}
			 ],
	  funcs:[],
	  funcId:"",
	  roleDatas:[]
    };
  },
  created() {	  
	  let userMenus=JSON.parse(sessionStorage.getItem("userMenu"));
	  let userMenu= userMenus.find(item => item.funcLangCode==="用户管理");
	  if(userMenu!=null){
	  		this.getUsers();
	  }else{
	  		Message(
	  		{
	  		 type: "error",
	  		 message: "没有权限",
	  		 offset:window.screen.height/2-100
	  		});  
	  		this.$router.push('/user');
	  }
  },
  methods:{
	  add(){
		  this.showModal=true;
		  this.msg="";
	  },
	  async getUsers(){
		  this.msg="";
		  let res=await this.$axios.post(this.$serverUrl+"/user/getUsers",this.searchData).then(		  
		  response => {
			  if(response.status==200){
			    this.users=response.data.data.list;
			  }else{
			  	this.msg=response.data.msg;
			  }
		    }
		  ).catch(
		  error => {
		      // 请求失败处理逻辑
		      if (error.response) {
		        // 请求已发出，服务器用状态码响应
		        if (error.response.status === 500) {
		          Message(
				  {
				   type: "error",
				   message: "服务器内部错误。"+error.response.status,
				   offset:window.screen.height/2-100
				  });
		          // 在这里处理500错误，例如提示用户、重试请求等
		        } else {
		          // 处理其他HTTP错误
		        }
		      } else if (error.request) {
		        // 请求未发出，可能是请求构建时出错
		        //console.error('请求构建错误：', error.request);
		      } else {
		        // 响应解析错误
		        //console.error('错误：', error.message);
		      }
		    }
		  );
	  },
	  handleCurrenChange(val){
		this.currentRow=val;
	  },
	  edit(){		
		if(this.currentRow!=null){
			this.$axios.get(this.$serverUrl+"/role/list").then(
			  response => {
							this.roleDatas=response
							if(response.data.status=="1"){
								this.roleDatas=response.data.data
							  }
						}
			);
			this.init();
			this.showModal2=true;
			this.userDetail.name=this.currentRow.name;
			this.userDetail.loginName=this.currentRow.loginName;
			this.userDetail.mobile=this.currentRow.mobile;
			this.userDetail.userState=this.currentRow.userState;
			this.userDetail.id=this.currentRow.id;
		    this.userDetail.roleId=this.currentRow.roleId;
			this.userDetail.email=this.currentRow.email;
			
		}else{
			Message(
			{
			 type: "error",
			 message:"请选择一个用户",
			 offset:window.screen.height/2-100
			});
		}
	  },
	  save(){
		this.$axios.post(this.$serverUrl+"/user/update",this.userDetail).then(		    
			response => {	
			  if(response.data.status=="1"){
				this.getUsers();
				this.showModal2=false;
				this.init();
			  }else{
				Message(
				{
				 type: "error",
				 message:response.data.msg,
				 offset:window.screen.height/2-100
				});
			  }
			}
		);
	  },
	  init(){
		  this.userDetail.userName="";
		  this.userDetail.loginName="";
		  this.userDetail.mobile="";
		  this.userDetail.userState="";
	  },
	  async invite(){
	  		  this.msg="";
	  		  let res =await this.$axios.post(this.$serverUrl+"/user/invite",this.invitation);
	  		  if(res.data.data!=null){
	  		    this.msg="已邀请"+this.invitation.tel+"注册，验证码"+res.data.data.inviteCode+"已发送，3天有效。"
	  				this.list();
	  		  }else{
	  			this.msg="该号码已经存在未使用邀请码";
	  		  }
	  },
	  roles(){
		  this.$axios.get(this.$serverUrl+"/role/list").then(
		    response => {
				this.roleDatas=response
		      if(response.data.status=="1"){
		  		this.roleDatas=response.data.data
		  	  }
			}
		  );
		  this.$axios.get(this.$serverUrl+"/func/list").then(
		    response => {
		      if(response.data.status=="1"){
		  		this.allFuncs=response.data.data
		  	  }
		  	}
		  );

		this.showModal3=true;		
	  },
	  getFuncs(val){
		  this.funcs=[];
		  this.$axios.get(this.$serverUrl+"/role/func/list?roleId="+val).then(
		    response => {
				response.data.list.map((item,index)=>{	
				this.funcs.push(item.funcLangCode);
				})
            }			
		  );
	  },
	  addFunc(roleId){
		  this.$axios.post(this.$serverUrl+"/role/addFunc",{roleId:roleId,funcId:this.funcId}).then(
		    response => {
		  				//response.data.list.map((item,index)=>{	
		  				//this.funcs.push(item.funcLangCode);
		  				//})
						this.getFuncs(roleId);
		    }			
		  );
		  
	  },
		handleClose(tag,roleId) {
		  MessageBox.confirm("确定要删除 “"+tag+"”?","确认",{
		    distinguishCancelAndClose: true,
		    confirmButtonText: '确定',
		    cancelButtonText: '取消',
		    type: 'warning',
		    offset:window.screen.height/2-100
		  }).then(()=>{
		      this.$axios.post(this.$serverUrl+"/role/delFunc",{roleId:roleId,funcName:tag}).then(
		  		response => {			
		  		  if(response.data.status==1){
		  			this.getFuncs(roleId);
		  		  }else{
		  			Message(
		  			{
		  			 type: "error",
		  			 message: response.data.msg,
		  			 offset:window.screen.height/2-100
		  			});
		  		  }
		  		}
		  	).catch(			
		  		error=>{
		  			if(error.response.data.state===500){
		  			Message(
		  			{
		  			 type: "error",
		  			 message: "系统出错了。",
		  			 offset:window.screen.height/2-100
		  			});
		  			}
		  	})
		  	});
		},
  }
};
</script>
<style></style>
